module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rows"
  }, _vm._l((_vm.secteurs.data), function(secteur) {
    return _c('div', {
      key: secteur.id,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-5"
    }, [_c('span', {
      staticClass: "title-item"
    }, [_vm._v("Nom")]), _vm._v(" "), _c('span', {
      staticClass: "text-item"
    }, [_vm._v(_vm._s(secteur.nom))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-5"
    }, [_c('span', {
      staticClass: "title-item"
    }, [_vm._v("Arrondissement")]), _vm._v(" "), _c('span', {
      staticClass: "text-item"
    }, [_vm._v("\n        " + _vm._s(_vm._f("arrondissementName")(secteur.arrondissement_id)) + "\n      ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2"
    }, [_c('div', {
      staticClass: "actions"
    }, [_c('a', {
      staticClass: "action-edit",
      on: {
        "click": function($event) {
          return _vm.$emit('edit', secteur)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../../../static/img/edit-icon.svg")
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "action-delete right-separator",
      on: {
        "click": function($event) {
          return _vm.$emit('delete', secteur)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../../../static/img/delete-icon.svg")
      }
    })])])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1a6bff1e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/secteurs/SecteursList.vue
// module id = 2087
// module chunks = 2